import { render, staticRenderFns } from "./StyleViewSampleRequests.vue?vue&type=template&id=0f73295f&"
import script from "./StyleViewSampleRequests.vue?vue&type=script&lang=js&"
export * from "./StyleViewSampleRequests.vue?vue&type=script&lang=js&"
import style0 from "./StyleViewSampleRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports